// Port of api/fuel/app/classes/controller/api/monty/listing/order.php
import {
	LIST_TYPE_MANUAL,
	currentEdition,
	currentUserId,
	loadListingEdition,
	loadOwnedListing,
	parseGameIndex,
	persist,
	saveEditionGames,
	unauthorised,
	uniqueIndex
} from './shared'

export default function(params) {
	var userId = currentUserId(params)
	var listing = loadOwnedListing(userId, params.list)
	var edition = null
	var order = []
	var item = parseInt(params.item, 10) || 0
	var newPosition = parseInt(params.position, 10)
	var oldPosition = -1

	if (!userId) return unauthorised()
	if (!listing || listing.get_type() !== LIST_TYPE_MANUAL) return unauthorised()

	edition = loadListingEdition(listing, params.edition) || currentEdition(listing)
	if (!edition) return Promise.reject({ error: 120, offline: true })

	if (params.order) {
		order = uniqueIndex(params.order)
	} else {
		order = parseGameIndex(edition.get_index_games())
		oldPosition = order.indexOf(item)

		if (oldPosition !== -1 && !isNaN(newPosition)) {
			order.splice(oldPosition, 1)
			if (newPosition <= oldPosition) order.splice(newPosition, 0, item)
			else order.splice(newPosition - 1, 0, item)
		}
	}

	saveEditionGames(edition.get_id(), order)
	return persist({})
}
